// extracted by mini-css-extract-plugin
module.exports = {"electionResult":"resultTally_electionResult__jEJND"};